import Divider from "components/MeForm/Divider";
import CardSectionRow from "./CardSectionRow";
import { classNames } from "tools/ui";

function ChartCard({
  children,
  header,
  header_meta,
  desc,
  desc_meta,
  getReport,
  style,
}) {
  function onClick() {
    getReport();
  }

  const base = "shadow-md rounded-md px-4 bg-white w-full py-4";
  const zoneClickable =
    "active:scale-95 active:bg-slate-100 active:px-3 cursor-pointer";
  return (
    <div id="chart-card" className={classNames(base, style)}>
      {header && !getReport && (
        <div className="flex items-center justify-between text-slate-800 mb-3">
          <span className="font-semibold text-base">{header}</span>
          {header_meta && <span className="text-slate-500">{header_meta}</span>}
        </div>
      )}
      {children}
      {getReport && (
        <div className={classNames(zoneClickable)} onClick={onClick}>
          <Divider className="" />
          <CardSectionRow
            content1={header}
            content2={header_meta}
            style="text-slate-800"
          />
          {desc && (
            <CardSectionRow
              style="text-sky-500"
              content1={desc}
              content2={desc_meta}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default ChartCard;
